import { dateFns } from "utilities";

export const formatMonth = (date: Date) => {
  return {
    displayValue: dateFns.format(date, "LLLL"),
    firstDay: dateFns.format(date, "yyyy-MM-01"),
    lastDay: dateFns.format(dateFns.lastDayOfMonth(date), "yyyy-MM-dd"),
  };
};
